import { Component, Event, EventEmitter, h, Host, Prop, State, Watch } from '@stencil/core';
import { pathStore } from '@store/path-store';
import { If } from '@utils/If';

@Component({
  tag: 'input-field',
  styleUrl: 'input-field.scss',
  shadow: false
})
export class AppInput {
  @Prop() autoFocus: boolean = false;
  @Prop() name: string;
  @Prop() disabled: boolean = false;
  @Prop() label: string;
  @Prop() error?: string = '';
  @Prop() value: string;
  @Prop() type: string = 'text';
  @Prop() inputMode: string = 'text';
  @Prop() maxLength?: number;
  @Prop() fieldInfo?: string;
  @Prop() rightIcon?: string;
  @Prop() readOnly: boolean = false;
  @Prop() loading: boolean = false;
  @Prop() max: string;
  @Prop() restrictInput: boolean = false;
  @Prop() inputType: 'text' | 'number' = 'text';
  @Event() valueChanged: EventEmitter<string>;
  @Event() focused: EventEmitter<void>;
  @Event() blurred: EventEmitter<void>;
  @Event() clickRightIcon: EventEmitter<void>;

  @State() isFocused: boolean = false;
  inputEl?: HTMLInputElement;
  private handleInput = (e: Event) => {
    const target = e.target as HTMLInputElement;
    this.valueChanged.emit(target.value);
  };

  @Watch('autoFocus')
  onActiveChange(newValue: boolean) {
    if (newValue) setTimeout(() => this.inputEl?.focus(), 300);
  }

  onKeypress = (event: any) => {
    if (this.restrictInput) {
      if (this.inputType === 'number' && !/^\d*$/.test(event.key)) {
        event.preventDefault();
      }
      if (
        this.inputType === 'text' &&
        !/^[a-zA-Z .]$/.test(event.key) // allow letters, space, and dot only
      ) {
        event.preventDefault();
      }
    }
  };

  private handleFocus = () => {
    this.focused.emit();
    this.isFocused = true;
  };

  private handleBlur = () => {
    this.blurred.emit();
    this.isFocused = false;
  };

  componentDidLoad() {
    if (this.autoFocus) setTimeout(() => this.inputEl?.focus(), 300);
  }
  openDatePicker() {
    if (this.inputEl) {
      this.inputEl.showPicker?.();
      this.inputEl.focus();
    }
  }

  render() {
    const assetPath = pathStore.assetPath;
    return (
      <Host>
        <div class="w-full flex flex-col">
          <div
            class={`border-2 border-solid rounded-[14px] ${this.isFocused ? (!!this.error ? 'border-sb-danger-300 ' : 'border-sb-primary-100') : 'border-transparent'
              } relative flex items-center`}
          >
            <input
              ref={el => (this.inputEl = el as HTMLInputElement)}
              id={this.name}
              name={this.name}
              type={this.type}
              autocomplete="off"
              inputMode={this.inputMode}
              value={this.value}
              maxLength={this.maxLength}
              max={this.max}
              disabled={this.disabled}
              readOnly={this.readOnly}
              placeholder="no remove"
              onInput={this.handleInput}
              onFocus={this.handleFocus}
              onBlur={this.handleBlur}
              onKeyPress={this.onKeypress}
              class={`w-full text-black border input border-solid rounded-xl px-5 py-2.5 ${this.error ? 'border-sb-danger' : 'border-gray-300 focus:border-sb-primary'
                } focus:outline-none text-lg/6.5 placeholder-transparent`}
            />
            <label
              htmlFor={this.name}
              class={`absolute  ${this.isFocused ? (!!this.error ? 'text-sb-danger' : 'text-sb-primary') : 'text-gray-500 text-sm'} 
                bg-white px-1 left-4 cursor-text top-[14px] transition-all pointer-events-none`}
            >
              {this.label}
            </label>
            {this.type === 'date' && <img class="absolute right-3" alt="calendar_icn" src={assetPath + 'images/icons/calendar.svg'} onClick={() => this.openDatePicker()} />}
          </div>
          <If
            condition={!!this.rightIcon}
            children={<i onClick={() => this.clickRightIcon.emit()} class={`absolute top-4 right-3 icon-${this.rightIcon} text-gray-500 cursor-pointer`} />}
          />
          <If condition={!!this.error} children={<p class="text-red-500 text-xs mt-1">{this.error}</p>} />
        </div>
      </Host>
    );
  }
}
